import { SyntheticEvent, useState } from "react";
import env, { ThemeOption } from "../common/env";
import { Link } from "react-router-dom";
import Title from "./Title";

const ConfigUser = () => {
  const [theme, setTheme] = useState(env.THEME.getTheme);
  const currentTheme = env.THEME.currentTheme;

  const isSelected = (color: ThemeOption) =>
    color === theme ? (
      <i className="fa-thin fa-check" style={{ marginRight: "-16px" }}></i>
    ) : (
      ""
    );
  const selectTheme = (color: ThemeOption) => (e: SyntheticEvent) => {
    e.preventDefault();
    setTheme(env.THEME.setTheme(color));
  };

  return (
    <>
      <Title icon="fa-screwdriver-wrench">
        Setări și administrare
      </Title>
      <div className="row">
        <div className="col">
          {" "}
          <details role="list">
            <summary aria-haspopup="listbox" style={{ width: "fit-content" }}>
              <i
                className={`fa-fw fa-lg ${
                  currentTheme === "dark"
                    ? "fa-duotone fa-moon-stars"
                    : "fa-light fa-sun-bright"
                }`}
              ></i>
            </summary>
            <ul role="listbox">
              <li>
                <a href="/" onClick={selectTheme("auto")}>
                  {isSelected("auto")}
                  <i className="ms-4 fa-fw fa-duotone fa-circle-half-stroke"></i>{" "}
                  Automat din setări sistem
                </a>
              </li>
              <li>
                <a href="/" onClick={selectTheme("light")}>
                  {isSelected("light")}
                  <i className="ms-4 fa-fw fa-light fa-sun-bright"></i>{" "}
                  Luminoasă
                </a>
              </li>
              <li>
                <a href="/" onClick={selectTheme("dark")}>
                  {isSelected("dark")}
                  <i className="ms-4 fa-fw fa-duotone fa-moon-stars"></i>{" "}
                  Întunecată
                </a>
              </li>
            </ul>
          </details>
        </div>
        <div className="col">
          <Link to="/login" className="float-end">
            <i className="fa-solid fa-arrow-right-from-arc text-warning me-2"></i>
            Deconectare
          </Link>
        </div>
      </div>
      <hr />
    </>
  );
};

export default ConfigUser;
